import { type MouseEventHandler, type ReactElement } from 'react'
import cn from 'classnames'

interface NormalButtonProps {
  additionalClasses?: string
  disabled?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  text: string
}

export function NormalButton ({ additionalClasses, onClick, text, disabled = false }: NormalButtonProps): ReactElement {
  return (
    <button
      className={cn(additionalClasses, 'w-full disabled:bg-std-light-gray-200 rounded-lg bg-wpy-blue-700 hover:bg-wpy-blue-600 active:bg-wpy-blue-500 text-white py-2 px-15')}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  )
}
